import { render, staticRenderFns } from "./AssignedApplianceList.vue?vue&type=template&id=65f41a8c&scoped=true"
import script from "./AssignedApplianceList.vue?vue&type=script&lang=js"
export * from "./AssignedApplianceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f41a8c",
  null
  
)

export default component.exports